(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $af1d8b04bb2dd986$exports = {};
"use strict";
var $f8c0bfabb91b689d$exports = {};
$f8c0bfabb91b689d$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $af1d8b04bb2dd986$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $af1d8b04bb2dd986$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $af1d8b04bb2dd986$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $af1d8b04bb2dd986$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $f8c0bfabb91b689d$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $af1d8b04bb2dd986$var$clipboardToIE11Formatting[options.format] || $af1d8b04bb2dd986$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $af1d8b04bb2dd986$var$format("message" in options ? options.message : $af1d8b04bb2dd986$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$af1d8b04bb2dd986$exports = $af1d8b04bb2dd986$var$copy;


function $da28f44bac693573$export$2cdf1b96a9f86d16(text) {
    (0, (/*@__PURE__*/$parcel$interopDefault($af1d8b04bb2dd986$exports)))(text);
} /*
export async function copyToClipboard(text: string) {
  await navigator.clipboard.writeText(text)
}
*/ 


//
// After a successful login we are redirected to the UI with our username
// and a JWT token. We need to save these in local storage so Verdaccio
// thinks we are logged in.
//
/**
 * Returns cookies as an object
 */ function $6b425c6f2ab299f1$export$d2e637738f5e6ae8(cookieStr) {
    return cookieStr.split(";").filter((str)=>str.includes("=")).map((str)=>str.split("=")).reduce((result, [key, value])=>({
            ...result,
            [decodeURIComponent(key.trim())]: decodeURIComponent(value.trim())
        }), {});
}
function $6b425c6f2ab299f1$export$83cd1f1503eb19c0(token) {
    // JWT has 3 parts separated by ".", the payload is the base64url-encoded part in the middle
    const base64Url = token.split(".")[1];
    // base64url replaced '+' and '/' with '-' and '_', so we undo it here
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("")// atob decoded the base64 string, but multi-byte characters (emojis for example)
    // are not decoded properly. For example, "🍀" looks like "ð\x9F\x8D\x80". The next
    // line converts bytes into URI-percent-encoded format, for example "%20" for space.
    // Lastly, the decodeURIComponent wrapping this can correctly get a UTF-8 string.
    .map((c)=>"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join(""));
    return JSON.parse(jsonPayload);
}
function $6b425c6f2ab299f1$export$9369b12211e1fce4(action) {
    for(let i = 0; i < 10; i++)setTimeout(()=>action(), 100 * i);
}
function $6b425c6f2ab299f1$var$pathContainsElement(selector, e) {
    const path = e.path || e.composedPath?.();
    const element = document.querySelector(selector);
    return path.includes(element);
}
function $6b425c6f2ab299f1$export$60561518b076cb2c(selector, callback) {
    const handleClick = (e)=>{
        if ($6b425c6f2ab299f1$var$pathContainsElement(selector, e)) {
            e.preventDefault();
            e.stopPropagation();
            callback();
        }
    };
    const capture = true;
    document.addEventListener("click", handleClick, capture);
}


function $2ea86d145a6282fb$export$787d85d17a1ab0c9(credentials) {
    localStorage.setItem("username", credentials.username);
    localStorage.setItem("token", credentials.uiToken);
    localStorage.setItem("npm", credentials.npmToken);
}
function $2ea86d145a6282fb$export$d1b63878dfcc70a6() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("npm");
}
function $2ea86d145a6282fb$export$256a5a3564694cfc() {
    return !!localStorage.getItem("username") && !!localStorage.getItem("token") && !!localStorage.getItem("npm");
}
function $2ea86d145a6282fb$export$b007d77a962aa175() {
    const token = localStorage.getItem("token");
    if (typeof token !== "string") return true;
    const payload = (0, $6b425c6f2ab299f1$export$83cd1f1503eb19c0)(token);
    if (!payload) return true;
    // Report as expired before (real expiry - 30s)
    const jsTimestamp = payload.exp * 1000 - 30000;
    return Date.now() >= jsTimestamp;
}
function $2ea86d145a6282fb$export$65f22a49577e07ee(credentials) {
    return credentials.username && credentials.uiToken && credentials.npmToken;
}


var $553b8fe3af4ab864$exports = {};
$553b8fe3af4ab864$exports = JSON.parse("{\"$schema\":\"http://json.schemastore.org/package\",\"name\":\"verdaccio-passport-google-oauth-ui\",\"version\":\"0.1.10\",\"keywords\":[\"authentication\",\"google\",\"login\",\"npm\",\"oauth\",\"package\",\"passport\",\"private\",\"registry\",\"verdaccio\",\"verdaccio-auth\",\"verdaccio-auth-plugin\",\"verdaccio-plugin\"],\"bugs\":\"https://github.com/okayasu/verdaccio-passport-google-oauth-ui/issues\",\"repository\":{\"url\":\"git+https://github.com/okayasu/verdaccio-passport-google-oauth-ui.git\"},\"license\":\"MIT\",\"author\":\"Masanori Okayasu\",\"main\":\"dist/server/index.js\",\"bin\":{\"verdaccio-passport-google-oauth-ui\":\"dist/cli/index.js\"},\"files\":[\"dist\",\"verdaccio.yaml\"],\"scripts\":{\"build\":\"bash run build\",\"clean\":\"bash run clean\",\"cli\":\"bash run cli\",\"cli:login\":\"bash run cli-login\",\"cli:publish\":\"bash run cli-publish\",\"cli:whoami\":\"bash run cli-whoami\",\"copy\":\"bash run copy\",\"coverage\":\"vitest --coverage\",\"dev\":\"run-s update start\",\"docker\":\"bash run docker_\",\"fix\":\"run-s format typecheck\",\"format\":\"prettier --write \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"format:check\":\"prettier --check \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"prepack\":\"bash run clean && bash run build\",\"start\":\"verdaccio -c verdaccio.yaml\",\"test\":\"vitest\",\"typecheck\":\"bash run typecheck\",\"update\":\"run-s prepack copy\",\"watch\":\"nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \\\"bun dev\\\"\"},\"dependencies\":{\"@verdaccio/core\":\"^8.0.0-next-8.31\",\"@verdaccio/url\":\"^13.0.0-next-8.31\",\"copy-to-clipboard\":\"^3.3.3\",\"dotenv\":\"^17.3.1\",\"express\":\"^5.1.0\",\"global-agent\":\"^3.0.0\",\"lodash\":\"^4.17.23\",\"minimist\":\"^1.2.8\",\"open\":\"^11.0.0\",\"ow\":\"^3.1.1\",\"passport\":\"^0.7.0\",\"passport-google-oauth\":\"^2.0.0\",\"picocolors\":\"^1.1.1\"},\"devDependencies\":{\"@parcel/config-default\":\"^2.16.4\",\"@parcel/transformer-typescript-tsc\":\"^2.16.4\",\"@types/express\":\"^5.0.3\",\"@types/global-agent\":\"^3.0.0\",\"@types/lodash\":\"^4.17.24\",\"@types/minimist\":\"^1.2.5\",\"@types/node\":\"^24.12.0\",\"@types/passport\":\"^1.0.17\",\"@types/passport-google-oauth\":\"^1.0.45\",\"@verdaccio/types\":\"^13.0.0-next-8.11\",\"@vitest/coverage-v8\":\"^4.0.18\",\"browserslist\":\"^4.28.1\",\"core-js\":\"^3.48.0\",\"nodemon\":\"^3.1.14\",\"npm-run-all2\":\"^8.0.4\",\"parcel\":\"^2.16.4\",\"prettier\":\"^3.8.1\",\"process\":\"^0.11.10\",\"timekeeper\":\"^2.3.1\",\"type-fest\":\"^5.4.4\",\"typescript\":\"^5.9.3\",\"verdaccio\":\"^6.3.1\",\"verdaccio-htpasswd\":\"^13.0.0-next-8.31\",\"vite-tsconfig-paths\":\"^6.1.1\",\"vitest\":\"^4.0.18\"},\"peerDependencies\":{\"verdaccio\":\">=6\"},\"engines\":{\"node\":\">=20\"},\"publishConfig\":{\"registry\":\"https://registry.npmjs.org/\"},\"targets\":{\"client\":{\"source\":\"src/client/verdaccio-6.ts\",\"distDir\":\"dist/client\",\"context\":\"browser\",\"includeNodeModules\":true},\"server\":{\"source\":\"src/server/index.ts\",\"distDir\":\"dist/server\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false,\"isLibrary\":true},\"cli\":{\"source\":\"src/cli/index.ts\",\"distDir\":\"dist/cli\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false}}}");


const $4306ab8084b84a30$export$3a689f099db7e338 = (0, (/*@__PURE__*/$parcel$interopDefault($553b8fe3af4ab864$exports))).name;
const $4306ab8084b84a30$export$18d4026d1ea86bb1 = (0, (/*@__PURE__*/$parcel$interopDefault($553b8fe3af4ab864$exports))).name.replace("verdaccio-", "");
const $4306ab8084b84a30$export$42fcb85fa5803dac = "/-/oauth/authorize";
const $4306ab8084b84a30$export$9e960429933a7149 = "/-/oauth/callback";
const $4306ab8084b84a30$export$cf98473208e53590 = $4306ab8084b84a30$export$42fcb85fa5803dac;
const $4306ab8084b84a30$export$bd46c9d2d39fc9 = "/";
const $4306ab8084b84a30$export$3c6c1020e175037c = 8239;
const $4306ab8084b84a30$export$32fbdff0ec95e1c6 = "cli";
const $4306ab8084b84a30$export$b3d17af05dbcae2f = "/oauth/authorize";
const $4306ab8084b84a30$export$827c2d0b213c39b9 = [
    "$all",
    "@all",
    "$authenticated",
    "@authenticated"
];




function $72c399d626f5a005$var$saveAndRemoveCookies() {
    if ((0, $2ea86d145a6282fb$export$b007d77a962aa175)()) (0, $2ea86d145a6282fb$export$d1b63878dfcc70a6)();
    const credentials = (0, $6b425c6f2ab299f1$export$d2e637738f5e6ae8)(document.cookie);
    if (!(0, $2ea86d145a6282fb$export$65f22a49577e07ee)(credentials)) return;
    (0, $2ea86d145a6282fb$export$787d85d17a1ab0c9)(credentials);
    Object.keys(credentials).forEach((key)=>document.cookie = `${key}=;expires=${new Date(0).toUTCString()}`);
    location.reload();
}
function $72c399d626f5a005$export$2cd8252107eb640b(options) {
    $72c399d626f5a005$var$saveAndRemoveCookies();
    const { loginButton: loginButton, logoutButton: logoutButton, updateUsageInfo: updateUsageInfo } = options;
    (0, $6b425c6f2ab299f1$export$60561518b076cb2c)(loginButton, ()=>{
        if (location.pathname === (0, $4306ab8084b84a30$export$cf98473208e53590)) location.reload();
        else location.href = (0, $4306ab8084b84a30$export$cf98473208e53590);
    });
    (0, $6b425c6f2ab299f1$export$60561518b076cb2c)(logoutButton, ()=>{
        (0, $2ea86d145a6282fb$export$d1b63878dfcc70a6)();
        location.href = (0, $4306ab8084b84a30$export$bd46c9d2d39fc9);
    });
    document.addEventListener("click", ()=>(0, $6b425c6f2ab299f1$export$9369b12211e1fce4)(updateUsageInfo));
    (0, $6b425c6f2ab299f1$export$9369b12211e1fce4)(updateUsageInfo);
}


//
// Replace the default npm usage info and displays the authToken that needs
// to be configured.
//
function $a904a0e265c2cc70$export$9dc0174526f4c7e3() {
    const username = localStorage.getItem("username");
    if (!username) return "Click the login button to authenticate with Google.";
    const configBase = window.VERDACCIO_API_URL ? window.VERDACCIO_API_URL.replace(/^https?:/, "").replace(/-\/verdaccio\/$/, "") : `//${location.host}${location.pathname}`;
    const authToken = localStorage.getItem("npm");
    return [
        `npm config set ${configBase}:_authToken "${authToken}"`
    ].join("\n");
}




const $8866254055c1a636$var$loginButtonSelector = `[data-testid="header--button-login"]`;
const $8866254055c1a636$var$logoutButtonSelector = `[data-testid="header--button-logout"],[data-testid="logOutDialogIcon"]`;
const $8866254055c1a636$var$tabSelector = `[data-testid="tab-content"]`;
function $8866254055c1a636$var$updateUsageInfo() {
    const loggedIn = (0, $2ea86d145a6282fb$export$256a5a3564694cfc)();
    if (!loggedIn) return;
    const tabs = document.querySelectorAll($8866254055c1a636$var$tabSelector);
    if (!tabs) return;
    const usageInfoLines = (0, $a904a0e265c2cc70$export$9dc0174526f4c7e3)().split("\n").reverse();
    tabs.forEach((tab)=>{
        const alreadyReplaced = tab.getAttribute("replaced") === "true";
        if (alreadyReplaced) return;
        const commands = Array.from(tab.querySelectorAll("button")).map((node)=>node.parentElement).filter((node)=>!!node.innerText.match(/^(npm|pnpm|yarn)/));
        if (!commands.length) return;
        usageInfoLines.forEach((info)=>{
            const cloned = commands[0].cloneNode(true);
            const textEl = cloned.querySelector("span");
            textEl.innerText = info;
            const copyEl = cloned.querySelector("button");
            copyEl.style.visibility = loggedIn ? "visible" : "hidden";
            copyEl.onclick = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                (0, $da28f44bac693573$export$2cdf1b96a9f86d16)(info);
            };
            commands[0].parentElement.appendChild(cloned);
            tab.setAttribute("replaced", "true");
        });
        // Remove commands that don't work with oauth
        commands.forEach((node)=>{
            if (node.innerText.includes("adduser") || node.innerText.includes("set password")) {
                node.parentElement.removeChild(node);
                tab.setAttribute("replaced", "true");
            }
        });
    });
}
(0, $72c399d626f5a005$export$2cd8252107eb640b)({
    loginButton: $8866254055c1a636$var$loginButtonSelector,
    logoutButton: $8866254055c1a636$var$logoutButtonSelector,
    updateUsageInfo: $8866254055c1a636$var$updateUsageInfo
});

})();
//# sourceMappingURL=verdaccio-6.js.map
